import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { setData } from '../../../actions/index';
import HomeworkDetails from './HomeworkDetails';
import ErrorBoundary from '../Error/ErrorBoundary';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  content: {
    padding: isMobileApp
      ? 20
      : '20px 80px',
    margin: '10px auto',
    width: '100%',
    textAlign: 'left',
    color: '#222',
    boxSizing: 'border-box',
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
    selectedPupil: state.selectedPupil,
    defaultDateRangeHomework: state.defaultDateRangeHomework,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class HomeworkDetailsDialog extends React.Component {
  render() {
    const {
      classes,
      isDialogOpen,
      onDialogClose,
      homework,
      homeworksMeta,
      reloadHomeworkData,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        className="homework-details-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onDialogClose}
          className={`homework-details-dialog-close-button ${classes.closeIcon}`}
        >
          <CloseIcon/>
        </IconButton>
        <div className={classes.content}>
          <ErrorBoundary location="HomeworkDetailsDialog.js->HomeworkDetails">
            <HomeworkDetails
              homework={homework}
              homeworksMeta={homeworksMeta}
              reloadHomeworkData={reloadHomeworkData}
            />
          </ErrorBoundary>
        </div>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(HomeworkDetailsDialog)))
);
